import script from "./CoursewareAudioPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoursewareAudioPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./CoursewareAudioPlayer.vue?vue&type=style&index=0&id=7ada02b7&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ada02b7"]])

export default __exports__